module.exports = __webpack_public_path__ + "static/media/babyhealth-details.21678dd5.jpg";